// The selected contractor, not the signed-in user, determines VAT.
export default {
  data() {
    return { contractNdsRate: null, vatContractId: null, vatRequest: 0 };
  },
  computed: {
    vatAct() { return this.new_act || this.current_act; },
    vatSelectedContractId() {
      return this.vatAct && this.vatAct.contract && this.vatAct.contract.id;
    },
    vatReady() {
      return this.contractNdsRate !== null &&
        String(this.vatContractId) === String(this.vatSelectedContractId);
    },
  },
  watch: {
    vatSelectedContractId: {
      immediate: true,
      handler(id, previousId) { this.loadVatRate(id, previousId); },
    },
    '$store.getters.USER.nds_size'() {
      this.loadVatRate(this.vatSelectedContractId, this.vatSelectedContractId);
    },
  },
  methods: {
    async loadVatRate(id, previousId) {
      const request = ++this.vatRequest;
      this.contractNdsRate = null;
      this.vatContractId = null;
      if (!id) return;
      try {
        const response = await this.$store.dispatch('getContractDetail', id);
        if (request !== this.vatRequest) return;
        const raw = response.data.impl_company && response.data.impl_company.nds;
        const rate = Number(raw);
        if (raw === null || raw === undefined || raw === '' ||
            !Number.isFinite(rate) || rate < 0) {
          throw new Error('Ставка НДС подрядчика не указана');
        }
        this.contractNdsRate = rate;
        this.vatContractId = id;
        // Opening an existing document must not rewrite its saved/manual amounts.
        if (previousId) this.recalculateVat();
      } catch (error) {
        if (request !== this.vatRequest) return;
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: 'Не удалось загрузить ставку НДС подрядчика. Выберите договор повторно или обновите страницу.',
        });
      }
    },
    profile_nds_rate() { return this.contractNdsRate / 100; },
    requireVatRate() {
      if (this.vatReady) return true;
      this.$store.dispatch('addNotification', {
        type: 'warning', message: 'Дождитесь загрузки ставки НДС подрядчика выбранного договора.',
      });
      return false;
    },
    recalculateVat() {
      const act = this.vatAct;
      if (this.auto_calc_mmg) {
        (act.rows || []).forEach((row, index) => this.auto_calc_mmg(index, 1));
        this.auto_calc2();
        if (act.dbikrs_inner_type === 'Бурение') this.auto_calc_mmg_accmini();
        if (act.dbikrs_inner_type === 'КРС') this.auto_calc3();
        if (act.dbikrs_inner_type === 'Супервайзер') this.auto_calc_supervisor();
        if (act.ptopd_inner_type === 'ПРС' && (act.rows_prs || []).length) this.auto_calc_prs();
        if (act.ptopd_inner_type === 'Перевозка насосов' && (act.rows_pump || []).length) this.auto_calc_pump();
        if (act.ptopd_inner_type === 'Химизация' && (act.rows_chem || []).length) this.chem_totals_from_total();
      } else {
        this.auto_calc2();
        act.nds = this.toFixedFloat2(Number(act.total || 0) * this.profile_nds_rate());
        act.total_with_nds = this.toFixedFloat2(Number(act.total || 0) + act.nds);
      }
    },
  },
};
